import React, { createContext, useContext, useState, useCallback } from "react";

const LangContext = createContext(null);

const UI = {
  ro: {
    nav: { home: "Acasă", portfolio: "Portofoliu", about: "Despre noi", contact: "Contact", quote: "Solicită ofertă" },
    common: { viewPortfolio: "Vezi portofoliul", requestQuote: "Solicită ofertă", callNow: "Sună acum", learnMore: "Detalii", getEstimate: "Solicită o estimare rapidă", leaveReview: "Lasă o recenzie pe Google", seeAllReviews: "Vezi toate recenziile" },
  },
  en: {
    nav: { home: "Home", portfolio: "Portfolio", about: "About", contact: "Contact", quote: "Request a quote" },
    common: { viewPortfolio: "View portfolio", requestQuote: "Request a quote", callNow: "Call now", learnMore: "Details", getEstimate: "Get a fast estimate", leaveReview: "Leave a Google review", seeAllReviews: "See all reviews" },
  },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") return localStorage.getItem("voltpdr_lang") || "ro";
    return "ro";
  });
  const set = useCallback((l) => {
    setLang(l);
    if (typeof window !== "undefined") localStorage.setItem("voltpdr_lang", l);
  }, []);
  const toggle = useCallback(() => set(lang === "ro" ? "en" : "ro"), [lang, set]);
  const L = useCallback((obj) => (obj && typeof obj === "object" ? obj[lang] ?? obj.ro : obj), [lang]);
  const ui = UI[lang];
  return (
    <LangContext.Provider value={{ lang, setLang: set, toggle, L, ui }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
